<template>
    <div class="charts">
        <filters v-if="showFilters" class="filters" @filter="onFilter" />
        <div
            v-if="showEvaluationsStatus || showEvaluationsStatusBySections"
            class="charts-group"
        >
            <div class="title">
                {{ $t('reports.dashboards.networkAndProcess') }}
            </div>
            <evaluations-status
                v-if="showEvaluationsStatus"
                class="chart"
                :filters="filters"
            />
            <evaluations-status-by-sections
                v-if="showEvaluationsStatusBySections"
                class="chart"
                :filters="filters"
            />
        </div>
        <div
            v-if="showQuestionnaireResults || showSubjectsResults"
            class="charts-group"
        >
            <div class="title">
                {{ $t('reports.dashboards.scoresAndResults') }}
            </div>
            <questionnaires-results
                v-if="showQuestionnaireResults"
                class="chart"
                :filters="filters"
            />
            <subjects-score-by-network
                v-if="showSubjectsResults"
                class="chart"
                :filters="filters"
            />
        </div>
    </div>
</template>

<script>
import {
    Filters,
    EvaluationsStatus,
    QuestionnairesResults,
    SubjectsScoreByNetwork,
    EvaluationsStatusBySections,
} from './components'
import { Questionnaires } from '@/views/values/components'
export default {
    components: {
        Filters,
        Questionnaires,
        EvaluationsStatus,
        QuestionnairesResults,
        SubjectsScoreByNetwork,
        EvaluationsStatusBySections,
    },
    props: {
        showSubjectsResults: Boolean,
        showEvaluationsStatus: Boolean,
        showQuestionnaireResults: Boolean,
        showEvaluationsStatusBySections: Boolean,
        showFilters: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            filters: {
                users: [],
                committees: [],
                departments: [],
                questionnaires: [],
            },
        }
    },
    methods: {
        onFilter(filters) {
            this.filters = filters
        },
    },
}
</script>

<style lang="scss" scoped>
.charts {
    .filters {
        display: flex;
        justify-content: flex-end;
        width: 100%;
    }

    .charts-group {
        margin-bottom: 24px;

        .title {
            font-size: 24px;
            font-weight: 700;
        }

        .chart {
            margin-bottom: 10px;
            animation-name: fadeIn;
            animation-duration: 0.4s;

            &:last-child {
                margin-bottom: 0;
            }
        }
    }
}
</style>
